import { render, staticRenderFns } from "./AboutHero.vue?vue&type=template&id=1a2c0937&scoped=true&"
import script from "./AboutHero.vue?vue&type=script&lang=ts&"
export * from "./AboutHero.vue?vue&type=script&lang=ts&"
import style0 from "./AboutHero.vue?vue&type=style&index=0&id=1a2c0937&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2c0937",
  null
  
)

export default component.exports